module.exports = function(scope, __mc__view, __mc__mcore) { // index
    var __mc__util = {
        clone: __mc__mcore.util.clone,
        build: function(tagName, key, attr, dynamicAttr, events, children) {
            return new __mc__mcore.Element(tagName, key, attr, dynamicAttr, children, events, __mc__view)
        },
        parseDynamicVal: function(dynamicCode, dynamicCodeStr) {
            return __mc__mcore.util.parseDynamicVal(dynamicCode, dynamicCodeStr, __mc__view)
        },
        callFormatter: function(formatterName) {
            return __mc__mcore.util.callFormatter(formatterName, __mc__mcore)
        }
    }
    var __mc__tree = [];


    (function(scope, __mc__tree, __mc_path) {
        // parseDomDef

        // ![mc-for]
        var __mc__forArr = [0]

        // buildArray
        __mc__forArr.forEach(function(__mc__$vn_, __mc__i) {

            var __mc__children

            // parseAttr
            var __mc__attr = {},
                __mc__dynamicAttr = {},
                __mc__event = {}

            __mc__dynamicAttr['class'] = __mc__util.parseDynamicVal(('mc-popover ' + scope.className), '\'mc-popover \' + scope.className')


            // build
            __mc__children = []

            var __mc__pathSubI = String(__mc_path + '.' + (__mc__tree.length));

            (function(scope, __mc__tree, __mc_path) {
                // parseDomDef

                // ![mc-for]
                var __mc__forArr = [0]

                // buildArray
                __mc__forArr.forEach(function(__mc__$vn_, __mc__i) {

                    var __mc__children

                    // parseAttr
                    var __mc__attr = {},
                        __mc__dynamicAttr = {},
                        __mc__event = {}

                    __mc__attr['class'] = 'mc-popover-inner'


                    // build
                    __mc__children = []

                    var __mc__pathSubI = String(__mc_path + '.' + (__mc__tree.length));

                    (function(scope, __mc__tree, __mc_path) {
                        // parseDomDef

                        // parseText
                        var __mc__pathStaticI = __mc_path + '.' + __mc__tree.length
                        var __mc__strVal = {} // parseFormatters
                        var __mc__tmpAttr;
                        try {
                            __mc__tmpAttr = scope.err
                        } catch (err) {
                            console.error(err.stack)
                        }

                        __mc__strVal['rp_0'] = (function(x) {

                            return x == undefined ? '' : x
                        })(__mc__tmpAttr);

                        /* [formatter] {scope.err} */
                        var __mc__str = "" + __mc__strVal['rp_0'] + "";
                        var __mc__dynamicAttr = {
                            text: __mc__str
                        };
                        __mc__tree.push(__mc__util.build(
                            '_textNode', __mc__pathStaticI, {},
                            __mc__dynamicAttr, {}, []
                        ));

                    })(scope, __mc__children, __mc__pathSubI);

                    __mc__tree.push(
                        __mc__util.build(
                            'div', __mc__pathSubI, __mc__attr,
                            __mc__dynamicAttr, __mc__event, __mc__children
                        )
                    )


                })



            })(scope, __mc__children, __mc__pathSubI);

            (function(scope, __mc__tree, __mc_path) {
                // parseDomDef

                // ![mc-for]
                var __mc__forArr = [0]

                // buildArray
                __mc__forArr.forEach(function(__mc__$vn_, __mc__i) {

                    var __mc__children

                    // parseAttr
                    var __mc__attr = {},
                        __mc__dynamicAttr = {},
                        __mc__event = {}

                    __mc__attr['class'] = 'mc-popover-caret'


                    // build
                    __mc__children = []

                    var __mc__pathSubI = String(__mc_path + '.' + (__mc__tree.length));

                    __mc__tree.push(
                        __mc__util.build(
                            'div', __mc__pathSubI, __mc__attr,
                            __mc__dynamicAttr, __mc__event, __mc__children
                        )
                    )


                })



            })(scope, __mc__children, __mc__pathSubI);

            __mc__tree.push(
                __mc__util.build(
                    'div', __mc__pathSubI, __mc__attr,
                    __mc__dynamicAttr, __mc__event, __mc__children
                )
            )


        })



    })(scope, __mc__tree, '0');


    return __mc__tree
}


//////////////////
// WEBPACK FOOTER
// ./ui/popover/popover.tpl
// module id = 15
// module chunks = 0